export default {
  questions: state => state.questions,
  ticketFormByQuestions: state => state.ticketFormByQuestions,
  ticketForm: state => state.ticketForm,
  parentQuestionId: state => state.parentQuestionId,
  questionsSections: state => state.questionsSections,
  questionsTopics: state => state.questionsSections.map(section => section.children).flat(),
}
